import { render, staticRenderFns } from "./HorsePerfs.vue?vue&type=template&id=7bd62647&"
import script from "./HorsePerfs.vue?vue&type=script&lang=js&"
export * from "./HorsePerfs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports